import {Component, inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {SectionTable} from '../../../@domain/section-table';
import {Order} from '../../../@domain/order';
import {RestaurantTable} from '../../../@domain/restaurent-table';
import {Store} from "@ngrx/store";
import {ApiBaseService} from "../../../../../projects/vendors/src/lib/services/api-base.service";
import {AlertService} from "../../../../../projects/vendors/src/lib/services/alert.service";
import * as fromApp from '../../../app.reducer';
import {TableAvailabilityStatus} from "../../../@application/enum/TableAvailabilityStatus";
import {PathEnum} from "../../../@application/enum/path.enum";
import {ApiEnum} from "../../../@application/enum/api.enum";
import {CLEAR_CART} from "../store/place-order/place-order.action";
import {KeyValue} from '../../../../../projects/vendors/src/lib/services/form-helper';
import {OrderTypeDialogComponent} from './order-type-dialog/order-type-dialog.component';
import {MatDialog} from '@angular/material/dialog';


@Component({
    selector: 'lib-table-occupancy',
    templateUrl: './table-occupancy.component.html',
    styleUrl: './table-occupancy.component.css',
    standalone: false
})
export class TableOccupancyComponent implements OnInit {

  currentSection !: string;
  selectedSectionId = ''
  selectedSectionName = ''
  private dialog = inject(MatDialog)
  apiBaseService = inject(ApiBaseService);
  alertService = inject(AlertService);
  router = inject(Router)
  selectedTables: Set<RestaurantTable> = new Set<RestaurantTable>();
  orderType = '1'
  sectionTable = [] as SectionTable[];
  order !: Order
  orderOwnerId!: string;
  customerName!: string;
  customerPhone!: string;
  orderTypeKeyValue: KeyValue[] = [
    {key: '1', value: 'Dine In'},
    {key: '2', value: 'Take Away'},
    {key: '3', value: 'Delivery'}
  ]

  constructor(
    private store: Store<fromApp.AppState>
  ) {

  }

  ngOnInit(): void {
    this.loadSection()
    if (this.isSmallScreen()) {
      this.OnSelectOrderType()
    }

  }



  onTableSelectionChange(table: RestaurantTable, sectionId: string, sectionName: string): void {
    if (table.availabilityStatus === TableAvailabilityStatus.InUse && !table.canTakeMultipleOrders)
      return
    if (this.selectedTables.has(table)) {
      this.selectedTables.delete(table);
      this.selectedSectionId = sectionId
      this.selectedSectionName = sectionName
    } else {
      this.selectedTables.add(table);
      this.selectedSectionId = sectionId
      this.selectedSectionName = sectionName
    }
  }


  private transformSelectedTables() {
    const sectionId = this.selectedSectionId;
    const tables = Array.from(this.selectedTables).map(table => table.id);
    const orderType = +this.orderType;
    const orderOwnerId = this.orderOwnerId;
    const customerName = this.customerName;
    const customerPhone = this.customerPhone;
    return {sectionId, tables, orderType, orderOwnerId, customerName, customerPhone};
  }

  OnSelectedTables(): void {
    if (Array.from(this.selectedTables).length === 0)
      return this.alertService.showInfo('Info', 'Please select a table/s to place an order')
    const transformedData = this.transformSelectedTables();
    this.onPostOrder(transformedData)
  }

  // onOngoingOrder(data: TableResponse): void {
  //   const queryParams: any = {
  //     tableId: data.id,
  //     seatingCapacity: data.seatingCapacity,
  //     name: data.name,
  //     status: data.status,
  //   };
  // this.router.navigate([PathEnum.Home, PathEnum.Settings, PathEnum.RestaurantManagement, RestaurantPathEnum.Cart],{queryParams: queryParams})
  // }


  onStartOrder(data: any): void {
    const queryParams: any = {
      orderId: data
    };
    this.router.navigate([PathEnum.Home, PathEnum.PlaceOrder], {queryParams: queryParams})
  }

  onPostOrder(data: any) {
    this.store.dispatch(CLEAR_CART())
    this.apiBaseService.POST_API<Order>([ApiEnum.RestaurantModule, ApiEnum.Order], data)
      .subscribe({
        next: res => {
          this.order = res
          this.onStartOrder(this.order.id)
        }
      })
  }

  onSectionChange(sectionId: string): void {
    this.currentSection = sectionId;
  }

  scrollTo(section: string): void {
    document.getElementById(section)?.scrollIntoView();
    this.currentSection = section;
  }

  private loadSection() {
    this.apiBaseService.GET<SectionTable[]>([ApiEnum.RestaurantModule, ApiEnum.Section,
      ApiEnum.SectionTable])
      .subscribe(res => {
        this.sectionTable = res.map(section => {
          section.tableResponses = section.tableResponses
            .filter(table => table.status === 1)
            .sort((a, b) => a.name.localeCompare(b.name))
          return section;
        })
        this.currentSection = this.sectionTable[0].id;
      });
  }

  isSmallScreen(): boolean {
    return window.innerWidth <= 768;
  }

  OnSelectOrderType() {
    const dialogRef = this.dialog.open(OrderTypeDialogComponent, {
      width: '75%',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.orderType = result.orderType;
      }
    });
  }


  selectOrderType(key: string) {
    this.orderType = key;
  }
}



